// extracted by mini-css-extract-plugin
export default {"action-container":"VJtwZ","breakline":"gtFdW","timer":"brk9O"};